{
    "Capability": "Capability",
    "CapabilityEnabled": "Enabled",
    "AvailableTelServers": "Which Telephony Server types are available?",
    "AvailableLicences": "Which Site Licence types are available?",
    "Broadworks": "Cisco Broadworks",
    "Webex": "Webex Calling",
    "LegacyTelephony": "Legacy ^^(Broadsoft M6, Panasonic, Siemens)^^",
    "Legacy": "Legacy ^^(ONE, Presence, Lite, 1000, 2000)^^",
    "Enterprise": "Enterprise",
    "Teams": "MS Teams",
    "MaxTelsysCount": "Maximum number of Telephony Servers in this CME",
    "CxAnalytics": "CX Analytics",
    "CxIntegration": "CX Integration",
    "NewUI": "New UI",
    "ClassicCxSuiteToggle": "Classic / Cx Suite Toggle",
    "CxScore": "CX Score",
    "CxRecord": "CX Record",
    "CxTranscribe": "CX Transcribe",
    "CxTranscribeNeedsCxsOrCxr": "Needs CX Score or CX Record for this Telephony Server type",
    "CxTranscribeNeedsCxs": "Needs CX Score for this Telephony Server type",
    "CxTranscribeNeedsThis": "CX Transcribe needs this. Untick CX Transcribe first.",
    "CapabilityNotAvailable": "Not available",
    "AvailableFeatures": "Which features are available?",
    "AiAssist": "AI Assist",
    "NAME": "CMECapabilities"
}
